import type { AlertColor } from '@mui/material';

export enum RequestTypeEnum {
    add2FAfactor = 'add2FAfactor',
    addMember = 'addMember',
    editMember = 'editMember',
    addNetwork = 'addNetwork',
    addVehicleToFleet = 'addVehicle',
    addGuest = 'addGuest',

    createGroup = 'createGroup',
    createNetwork = 'createNetwork',
    createUser = 'createUser',
    createFleet = 'createFleet',
    createVehicle = 'createVehicle',
    createClient = 'createClient',
    createParking = 'createParking',

    getCompanies = 'getCompanies',
    getCompanyAdmins = 'getCompanyAdmins',
    getFleets = 'getFleets',
    getGroups = 'getGroups',
    getGroup = 'getGroup',
    getFleet = 'getFleet',
    getVehicles = 'getVehicles',
    getVehicle = 'getVehicle',
    getNetwork = 'getNetwork',
    getInvitation = 'getInvitation',
    getParking = 'getParking',
    getParkings = 'getParkings',
    getParkingAdmins = 'getParkingAdmins',
    getUserProfile = 'getUserProfile',

    editParking = 'editParking',
    editCompany = 'editCompany',
    editPricingMix = 'editPricingMix',
    editFlatDays = 'editFlatDays',
    editPricing = 'editPricing',
    editPassword = 'editPassword',

    error = 'error',
    unknown = 'unknown',
    operationFailed = 'operationFailed',
    register = 'register',

    updateGroup = 'updateGroup',
    updateNetwork = 'updateNetwork',
    updateFleet = 'updateFleet',
    updateVehicle = 'updateVehicle',
    updateUser = 'updateUser',
    updateCompany = 'updateCompany',

    deleteInvitation = 'deleteInvitation',
    deleteGroup = 'deleteGroup',
    deleteFleet = 'deleteFleet',
    deleteVehicle = 'deleteVehicle',
    deleteParkingAdminInvit = 'deleteParkingAdminInvit',
    deleteParking = 'deleteParking',
    deleteCompany = 'deleteCompany',
    deleteUser = 'deleteUser',

    confirmInvitationToGroup = 'confirmInvitationToGroup',
    refuseInvitationToGroup = 'refuseInvitationToGroup',
    logoutUser = 'logoutUser',
    sendEmailPasswordResetAction = 'sendEmailPasswordResetAction',
    loginWithRedirect = 'loginWithRedirect',
    verifyEmail = 'verifyEmail',

    inviteMember = 'inviteMember',

    removeMemberFromGroup = 'removeMemberFromGroup',
    removeVehiclesFromFleet = 'removeVehiclesFromFleet',
    removeGuest = 'removeGuest',
    remove2FAfactor = 'remove2FAfactor',

    loginWith2FA = 'loginWith2FA',
    expiredCode = 'expiredCode',
    expiredSession = 'expiredSession',
    getHolding = "getHolding",
    createHolding = "createHolding",

    getAccesses = 'getAccesses',
    getAccess = 'getAccess',
    createAccess = 'createAccess',
    updateAccess = 'updateAccess',
    deleteAccess = 'deleteAccess',

    // Parkings that don't ask for a pin code list plain accesses, so their toasts must not name one.
    getAccessesGeneric = 'getAccessesGeneric',
    getAccessGeneric = 'getAccessGeneric',
    createAccessGeneric = 'createAccessGeneric',
    updateAccessGeneric = 'updateAccessGeneric',
    deleteAccessGeneric = 'deleteAccessGeneric'
}

interface ToastProps {
    text: string, 
    messageKey?: string,
    requestType?: RequestTypeEnum, 
    code: number, 
    severity?: AlertColor,
    isDisplayed?: boolean,
    isLoadingCounter?: number,
}

export type { ToastProps };